import useWatchActiveOffers from './watchers/useWatchActiveOffers';
import useWatchUnlockedOffers from './watchers/useWatchUnlockedOffers';
import useWatchEligibleOffers from './watchers/useWatchEligibleOffers';
import useWatchAppliedOffers from './watchers/useWatchAppliedOffers';
import useAutoApplyBestOffer from './useAutoApplyBestOffer';
import useWatchFreeItemByMinSpendValueThreshold from './watchers/useWatchFreeItemByMinSpendValueThreshold';
import useBasket from '../../../hooks/basket/useBasket';

const useWatchOffers = () => {
  const { originalItems: items } = useBasket();

  useWatchActiveOffers();
  useWatchUnlockedOffers(items);
  useWatchEligibleOffers(items);
  useWatchAppliedOffers();
  useAutoApplyBestOffer(items);
  useWatchFreeItemByMinSpendValueThreshold();
};

export default useWatchOffers;
